import { userProfileSchema, type UserProfile } from '@ytclip/shared'
import { apiRequest } from '@/lib/api-client.ts'

export function fetchCurrentUser(): Promise<UserProfile> {
  return apiRequest('/me', userProfileSchema)
}
